module.exports = __webpack_public_path__ + "images/dingtalk/article-273bf561e65bd714dc5b1de79e25b2ae.jpg";